import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FAQSection from '@/pages/home/components/FAQSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import ContactSection from '@/pages/home/components/ContactSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CommentsSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <FAQSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
        <ContactSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}